// eslint-disable-next-line import/prefer-default-export, no-underscore-dangle
export const GetAlgoliaEnvironment = () => window.__CHURCHES_OF_CHRIST_SETTINGS__?.algolia_env || '';

export const IsRunningInFEDEnvironment = () => {
    const { location: { host } } = window;

    if (host.startsWith('localhost:30') // just in case it start in port 3002 or 3004 or something else
        || host.includes('churches-of-christ-qld.luminary.space')
    ) {
        return true;
    }

    return false;
};
